/**
 * Turns the recursive org tree's depth-1 nodes (departments) into URL-safe tab slugs.
 *
 * `root.subManagers` already *are* the departments — see `OrgNode` in `internalPlaygroundApi.ts`
 * and `buildOrgTree`'s `departments` array in `proxy-server/lib/internalPlaygroundTimeline.js`,
 * which the backend returns pre-sorted alphabetically by `groupLabel`. There is nothing to compute
 * here beyond a stable, readable slug per department — the tab list itself is just that array.
 */
import type { OrgNode } from '../../services/internalPlaygroundApi';

/** "Operations - DCM & Credit Risk" -> "operations-dcm-credit-risk". Not reversible and not meant
 * to be — a renamed department just gets a new slug, and an old bookmark falls back to Overview
 * (see the `Navigate` canonicalization in `InternalPlaygroundHiringTimelineView`). */
export function slugifyDepartment(label: string): string {
  return label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export interface DepartmentTab {
  value: string;
  label: string;
  node: OrgNode;
}

export function buildDepartmentTabs(root: OrgNode): DepartmentTab[] {
  return root.subManagers.map((node) => ({
    value: slugifyDepartment(node.groupLabel ?? node.personName),
    label: node.groupLabel ?? node.personName,
    node,
  }));
}
